export default {
    'please-select-a-team': 'Please select a team'
}